// Drop-in `fetch` that adds the atlas-pr routing header to requests aimed at
// the AlleyPin backend (AP_PINMED_URL), and passes everything else through
// untouched. Service modules import `fetch` from here instead of relying on
// the global, which centralizes the header injection without touching every
// call site.
import { AP_PINMED_URL } from "./envHelpers"
import { atlasPrHeader } from "./atlasPrHeader"

export const fetch = (url, init) => {
  const urlString = typeof url === "string" ? url : url?.toString?.() ?? ""
  const atlasHeader = atlasPrHeader()

  // 沒有 atlas header 時原封不動轉呼叫,保證與未導入前 byte-identical
  if (
    !Object.keys(atlasHeader).length ||
    !AP_PINMED_URL ||
    !urlString.startsWith(AP_PINMED_URL)
  ) {
    return globalThis.fetch(url, init)
  }

  // 用 Headers 合併,兼容 plain object / Headers instance / array-of-pairs
  const headers = new Headers(init?.headers)
  Object.entries(atlasHeader).forEach(([key, value]) => headers.set(key, value))

  return globalThis.fetch(url, { ...init, headers })
}
